import {createSelector} from 'reselect';
import props from './props';

export default createSelector(
    props.app.loaded,
    props.app.user,
    props.app.modal_tx,
    props.app.modal_qr,
    (loaded, user, modal_tx, modal_qr) => {
        return {
            loaded,
            user,
            modal_tx,
            modal_qr
        }
    }
)